
import FaqHome from "./Faqs"
import FaqButtonList from "./FaqButtonList"
export default function Faq() {
    return <main>
      <FaqHome/>
      <FaqButtonList/>
     </main>
}